import { render } from "./NewTDASubscriptionItem.vue?vue&type=template&id=11cfd4cf"
import script from "./NewTDASubscriptionItem.vue?vue&type=script&lang=js"
export * from "./NewTDASubscriptionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__